module.exports = __webpack_public_path__ + "img/11.a69750cf.jpg";